export default {
  slug: "rubymine",
  code: "RM",
  label: "RubyMine",
  isIDE: true,
  krakenDir: "RubyMine",
  thumbnailColor: "#FC801D",
  logoFamily: "ide",
  // The code highlight of the Demo Video banners (Figma "YouTube", "Code
  // highlight color" of the product section).
  codeHighlightColor: "#FE2857",
};
